<template>
  <Popper placement="left">
    <button
      class="cabinet__tbody-btn"
      aria-describedby="tooltip"
    />
    <template #content>
      <ul class="tooltip__list tooltip">
        <li class="tooltip__list-item">
          <router-link
            class="tooltip__list-item-text"
            :to="{ name: 'SupplyRequest', params: { id: item.id } }"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--show" />
            Просмотр
          </router-link>
        </li>
        <li
          v-if="hasRole('contractor') && !['Черновик', 'Отклонена', 'Создана', 'Ожидается выбор поставщика'].includes(item.status)"
          class="tooltip__list-item tooltip__list-favourites"
        >
          <router-link
            class="tooltip__list-item-text"
            :to="{ name: 'ReceiptOrder', params: { requestId: item.id } }"
          >
            <span class="tooltip__list-item-img tooltip__list-item-img--message" />
            Создать приходный ордер
          </router-link>
        </li>
      </ul>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper';
import { mapGetters } from 'vuex';

export default {
  name: 'ReceiptOrderTableTooltip',
  components: {
    Popper,
  },
  props: ['item'],
  computed: {
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),
  },
};
</script>

<style scoped></style>
